/** Route (without query) that hosts the MCP OAuth consent screen. */
export const OAUTH_CONSENT_PATH = '/oauth/consent';

/**
 * Returns the URL only if it is a same-origin relative path
 * (starts with a single "/", no scheme, no protocol-relative "//", no backslash); otherwise null.
 */
export function sanitizeReturnUrl(url: string | null | undefined): string | null {
    if (!url || !/^\/(?!\/)/.test(url) || url.includes('\\')) {
        return null;
    }
    return url;
}

/** True when the (already sanitised) return URL targets the OAuth consent route. */
export function isOAuthConsentReturnUrl(url: string | null): boolean {
    return !!url && url.split('?')[0] === OAUTH_CONSENT_PATH;
}
